import { PageHero } from "../components/PageHero";
import { ContactSection } from "../components/ContactSection";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHero
        index="/ 05"
        kicker="Connect With Me"
        titleLines={["Reach Out"]}
        subtitle="Available around the clock for cardiac consultation and referrals."
      />
      <ContactSection />
    </div>
  );
}
